import classnames from 'classnames'
import { getContrastingColor } from 'embed/utils'
import { css } from 'emotion'
import * as React from 'react'

import { PersonalizedStatuses, PersonalizedStatusText, PersonalizedStatusTexts } from 'embed/constants'
import { CreditOffer } from 'embed/constants/models'

import ThemeConsumer from 'embed/components/ThemeConsumer'

const CheckScallop = require('./check-scallop.svg')

const commonStyles = require('embed/styles/results')

interface Props {
  offer: CreditOffer
  onClick?: () => void
  tooltip?: React.ReactNode
}

export const DEFAULT_FLAG_TEXT = 'Matched for You'

export const OfferFlag = ({ onClick, offer, tooltip }: Props) => {
  const { details } = offer

  let flagText: PersonalizedStatusText | string | null = null
  // We're using `some` instead of `forEach` to return early. The order in `offerFlagKeys` will enforce the hierarchy
  // of which flagText to show when.
  PersonalizedStatuses.some((key) => {
    const hasStatus = Boolean(details[key])
    if (hasStatus) {
      flagText = PersonalizedStatusTexts[key]
    }
    return hasStatus
  })

  if (!flagText) {
    return null
  }

  if (details.preSelected) {
    flagText = DEFAULT_FLAG_TEXT
  }

  return (
    <ThemeConsumer>
      {({ colorPrimary, colorSecondary, colorTextPrimary, fontFamilyPrimary }) => (
        <div
          className={classnames(commonStyles.preApprovedSection, {
            [css`
              cursor: pointer;
            `]: !!onClick,
          })}
          onClick={onClick}
        >
          <div
            className={classnames(
              commonStyles.preApprovedFlag,
              css`
                background-color: ${colorPrimary};
                font-family: ${fontFamilyPrimary};
                svg path {
                  fill: ${getContrastingColor(colorSecondary, { black: colorTextPrimary })};
                }
                &::after {
                  border-color: ${colorPrimary};
                  border-right-color: transparent;
                }
              `,
            )}
          >
            <CheckScallop />
            {flagText}
          </div>
          {tooltip && <div>{tooltip}</div>}
        </div>
      )}
    </ThemeConsumer>
  )
}
